import { TThunkAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EOpenNewAnswerForm } from './openFormActionsTypes';
import { getNewAnswerFormStep } from '../../selectors/newAnswer';
import { ENewAnswerModalStep } from '../../types/newAnswer';
import { setNewAnswerFormStep } from './stepActionsTypes';
import { clearNewAnswerFormAction } from './newAnswearAction';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { TAnswerTarget } from '../../types/answers';
import { getObjectInfo, getObjectRating, getReviewsCount } from '../../selectors/objectInfo';
import { trackAnswerButtonClick } from '../../containers/NewAnswerButton/tracking';

export type TSetNewAnswerFormOpenPayload = {
  id: string;
  type: TAnswerTarget;
};
export type TSetNewAnswerFormOpen = ITypedReduxAction<EOpenNewAnswerForm.Open, TSetNewAnswerFormOpenPayload>;
export const setNewAnswerFormOpenAction: (payload: TSetNewAnswerFormOpenPayload) => TSetNewAnswerFormOpen =
  actionGenerator<EOpenNewAnswerForm.Open, TSetNewAnswerFormOpenPayload>(EOpenNewAnswerForm.Open);
export const setNewAnswerFormCloseAction = actionGenerator<EOpenNewAnswerForm.Close>(EOpenNewAnswerForm.Close);

export function setNewAnswerFormOpen(payload: TSetNewAnswerFormOpenPayload): TThunkAction<Promise<void>> {
  return async (dispatch, getState) => {
    const state = getState();
    const objectInfo = getObjectInfo(state);
    const objectId = objectInfo.objectId;
    const reviewId = payload.id;

    const rating = getObjectRating(state);
    const reviewsCount = getReviewsCount(state);

    trackAnswerButtonClick({ objectId, rating, reviewsCount, reviewId });

    dispatch(setNewAnswerFormOpenAction(payload));

    window.history.pushState({}, '');
    window.addEventListener(
      'popstate',
      () => {
        dispatch(setNewAnswerFormStep(ENewAnswerModalStep.Answer));
        dispatch(setNewAnswerFormCloseAction());
      },
      { once: true },
    );
  };
}

export function setNewAnswerFormClose(): TThunkAction<Promise<void>> {
  return async (dispatch, getState) => {
    const state = getState();
    const newAnswerStep = getNewAnswerFormStep(state);

    if (newAnswerStep === ENewAnswerModalStep.Success) {
      dispatch(clearNewAnswerFormAction());
    }

    dispatch(setNewAnswerFormStep(ENewAnswerModalStep.Answer));
    dispatch(setNewAnswerFormCloseAction());

    window.history.back();
  };
}
